__turbopack_context__.v({
  "container": "building-banner-module-scss-module__b3aDKa__container",
  "cta": "building-banner-module-scss-module__b3aDKa__cta",
  "description": "building-banner-module-scss-module__b3aDKa__description",
  "imageContainer": "building-banner-module-scss-module__b3aDKa__imageContainer",
  "textContainer": "building-banner-module-scss-module__b3aDKa__textContainer",
});
